import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: PesticideCreateInput!
  ) {
    createOnePesticide(data: $data) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Fitofármaco criado`, mutationTypes.CREATE)
)
